module.exports = __webpack_public_path__ + "static/media/close_circle_white.702102de.svg";